import React from 'react';
const problems = ['You arrive at training without a real plan', 'You spend hours preparing sessions before every training', 'You keep searching for new drills online', 'Skill levels in your squad vary wildly', "You don't know how to structure a full season progression", 'Sessions always feel improvised'];
export function ProblemSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto text-center" data-id="element-178">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-10 tracking-tight leading-tight" data-id="element-179">
          If you coach cricket, you're probably living one of these problems:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-180">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#16161F] border border-[#d4af37]/20 rounded-2xl p-4 shadow-sm" data-id="element-181">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-182">❌</span>
              <p className="text-white text-sm sm:text-base font-semibold leading-snug" data-id="element-183">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#d4af37] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-184">
          How many more sessions do you want to keep improvising?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#d4af37]/20 to-transparent w-full" data-id="element-185" />
      </div>
    </section>;
}